import { createSlice } from '@reduxjs/toolkit'
import { fetchDayTypes } from '../thunks/select'
import { fetchSchedule } from '../thunks/tranRoutes'
import { setCurrentTransport } from './select'

export const tranRoutesSlice = createSlice({
  name: 'tranRoutes',
  initialState: {
    route_id: '',
    day_type_id: '',
    direction: 'forward', // || backward
    schedule: [],
  },
  reducers: {
    setRouteId: (state, { payload }) => {
      state.route_id = payload
    },
    setDayTypeId: (state, { payload }) => {
      state.day_type_id = payload
    },
    setDirection: (state, { payload }) => {
      state.direction = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setCurrentTransport, (state, { payload }) => {
        // console.log('setCurrentTransport')
        state.route_id = ''
      })
      .addCase(fetchSchedule.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.schedule = payload?.data || []
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        // console.log('rejected')
        state.schedule = []
      })
      .addCase(fetchDayTypes.fulfilled, (state, { payload }) => {
        // console.log('fulfilled')
        state.day_type_id = payload?.data?.[0].type_id || ''
      })
  },
})

// Action creators are generated for each case reducer function
export const { setRouteId, setDayTypeId, setDirection } = tranRoutesSlice.actions

export const tranRoutesSelector = (state) => state.tranRoutes
export const tranRoutesReducer = tranRoutesSlice.reducer
